import { gql } from "@apollo/client";

export const trendingOnSpotlight = gql`
    query getTrendingOnSpotlight {
        trendingOnSpotlight {
            name
        }
    }
`;
